import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-system-label',
  templateUrl: './system-label.component.html',
  styleUrls: ['./system-label.component.css']
})
export class SystemLabelComponent implements OnInit {
  @Input() type: 'label' | 'dropdown' = 'label'
  @Input() dropIsActive: boolean;
  constructor() { }

  ngOnInit() {
  }

}
